<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>Identidade Comerciante</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding padding-horizontal">

    <div #Merchantpdf style="width: 720px; padding: 20px; margin: auto;">

        <ion-grid>

            <ion-row class="ion-padding-vertical ion-margin-vertical">
                <ion-col class="flex-justify-center ion-padding-top">
                    <h1 class="ion-text-center">{{Data?.Data?.Name}}</h1>
                </ion-col>
            </ion-row>
            <ion-row style="min-height: 400px;">
                <ion-col class="flex-justify-center">
                    <qr-code [value]="Code" size="300" errorCorrectionLevel="M" />
                </ion-col>
            </ion-row>
            <ion-row class="ion-margin-vertical ion-padding-vertical">
                <ion-col>

                    <div id="instructions">
                        <h3 class="ion-padding-horizontal ion-text-center ion-padding-bottom">Instruções de Utilização
                        </h3>

                        <ol style="font-size: 12px; line-height: 1.6;">
                            <li>
                                <strong>Instalar a aplicação móvel:</strong><br>
                                Aceda à loja de aplicações do seu dispositivo:
                                <ul>
                                    <li><strong>Android:</strong> Google Play Store</li>
                                    <li><strong>iOS:</strong> App Store</li>
                                </ul>
                                Procure por <em>"[Nome da aplicação]"</em> e instale a aplicação.
                            </li>

                            <li>
                                <strong>Efetuar a leitura por QR Code:</strong><br>
                                Abra a aplicação, aceda à área de <em>Registar consumo</em> e selecione "Ler Código".
                                Aponte a câmara do dispositivo para o código apresentado aqui.
                            </li>

                            <li>
                                <strong>Preencher os restantes dados:</strong><br>
                                Após a leitura, preencha os campos adicionais como por exemplo o apoio e valor da
                                comparticipação.
                            </li>

                            <li>
                                <strong>Apresentar o Código:</strong><br>
                                Após o registo, será apresentado um novo QR code. Utilize este novo código e apresente
                                ao comerciante para continuar o processo.
                            </li>
                        </ol>
                    </div>
                </ion-col>
            </ion-row>


        </ion-grid>
    </div>

</ion-content>
<ion-footer>
    <ion-toolbar class="ion-padding-end">
        <ion-buttons slot="end">
            <ion-button fill="solid" color="primary" (click)="GeneratePdf($event)">Descarregar</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>